import React, { useState } from 'react';
import { useData } from '../../context/DataContext';
import { Star, Check } from 'lucide-react';

const AdminFeatured = () => {
  const { projects, featuredProjectIds, setFeaturedProjects } = useData();
  const [selected, setSelected] = useState(featuredProjectIds || []);

  const toggleProject = (projectId) => {
    if (selected.includes(projectId)) {
      setSelected(selected.filter((id) => id !== projectId));
    } else if (selected.length < 5) {
      setSelected([...selected, projectId]);
    }
  };

  const handleSave = () => {
    setFeaturedProjects(selected);
    alert('Öne çıkan projeler kaydedildi!');
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-2xl font-bold text-white">Öne Çıkan Projeler</h1>
          <p className="text-gray-400 mt-2">
            Anasayfada gösterilecek 5 proje seçin ({selected.length}/5)
          </p>
        </div>
        <button
          onClick={handleSave}
          disabled={selected.length === 0}
          className="px-6 py-2 bg-gold text-anthracite font-medium rounded hover:bg-gold-light transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Kaydet
        </button>
      </div>

      {/* Selection Info */}
      {selected.length === 5 && (
        <div className="mb-6 p-4 bg-green-500/10 border border-green-500/20 rounded-lg">
          <p className="text-green-400 flex items-center space-x-2">
            <Check className="w-5 h-5" />
            <span>5 proje seçildi. Anasayfada gösterilecek.</span>
          </p>
        </div>
      )}

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project) => {
          const isSelected = selected.includes(project.id);
          const selectionOrder = selected.indexOf(project.id) + 1;

          return (
            <button
              key={project.id}
              onClick={() => toggleProject(project.id)}
              disabled={!isSelected && selected.length >= 5}
              className={`relative p-4 bg-anthracite-light rounded-lg border text-left transition-all duration-300 ${
                isSelected
                  ? 'border-gold shadow-lg shadow-gold/10'
                  : 'border-gold/10 hover:border-gold/30'
              } ${!isSelected && selected.length >= 5 ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {/* Selection Badge */}
              {isSelected && (
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold rounded-full flex items-center justify-center text-anthracite font-bold text-sm">
                  {selectionOrder}
                </div>
              )}

              {/* Image */}
              <img
                src={project.coverImage}
                alt={project.title}
                className="w-full h-32 object-cover rounded mb-4"
              />

              {/* Info */}
              <h3 className="text-white font-medium mb-1">{project.title}</h3>
              <div className="flex items-center gap-2">
                <span
                  className={`text-xs px-2 py-0.5 rounded ${
                    project.status === 'Biten'
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-gold/20 text-gold'
                  }`}
                >
                  {project.status}
                </span>
                <span className="text-gray-400 text-sm">{project.location}</span>
              </div>

              {/* Selection State */}
              <div
                className={`mt-4 py-2 text-center rounded text-sm font-medium transition-colors duration-300 ${
                  isSelected
                    ? 'bg-gold/10 text-gold'
                    : 'bg-anthracite text-gray-400'
                }`}
              >
                {isSelected ? (
                  <span className="flex items-center justify-center space-x-2">
                    <Star className="w-4 h-4 fill-gold" />
                    <span>Seçili</span>
                  </span>
                ) : (
                  'Seçmek için tıkla'
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AdminFeatured;